<script>
  export let options;
  export let metric;
</script>

<div class="description">
  {#each options as { value, text }}
    <p class:visible="{metric === value}">{text}</p>
  {/each}
</div>

<style>
  .description {
    margin-bottom: 2em;
  }

  p {
    display: none;
    text-align: center;
    font-size: 1em;
  }

  p.visible {
    display: block;
  }

  @media only screen and (min-width: 720px) {
    p {
      font-size: 1.25em;
    }
  }
</style>
